module.exports = __webpack_public_path__ + "img/diaohua8.6770d987.jpg";